import { Controller } from "@hotwired/stimulus"

// Shows the first N grid items; toggle reveals the rest (e.g. coming-soon features).
export default class extends Controller {
  static targets = ["item", "moreButton", "lessButton"]
  static values = { previewCount: { type: Number, default: 3 } }

  connect() {
    this.expanded = false
    this.applyVisibility()
  }

  toggle() {
    this.expanded = !this.expanded
    this.applyVisibility()
  }

  applyVisibility() {
    this.itemTargets.forEach((element, index) => {
      const hidden = !this.expanded && index >= this.previewCountValue
      element.classList.toggle("hidden", hidden)
    })

    if (this.hasMoreButtonTarget) {
      this.moreButtonTarget.classList.toggle("hidden", this.expanded)
    }
    if (this.hasLessButtonTarget) {
      this.lessButtonTarget.classList.toggle("hidden", !this.expanded)
    }
  }
}
